<template>
  <div class="main-box mh-a">
    <div
      class="h140px ovh lh140 fs30 c-white text-center solution-title"
      :style="`background-image: url(${solutionDetial.showImg});`"
    >
      {{ solutionDetial.title }}
    </div>
    <div
      class="m-fa"
      v-for="(item, index) in solutionDetial.infoData"
      :key="`${index}_sif`"
    >
      <h3>{{ item.title }}</h3>
      <p
        class="fs14 c-g-d ph40 lh24 text-indent"
        v-for="(txt, i) in item.data"
        :key="`${i}_sif_txt`"
      >
        {{ txt }}
      </p>
    </div>
    <div class="p40">
      <el-image
        class="w-total"
        :src="solutionDetial.infoImg"
        fit="cover"
      ></el-image>
    </div>
  </div>
</template>

<script>
// import SalesHotline from "@/components/SalesHotline";
import solutionList from "@/assets/solution/solutionList";
import solutionListEn from "@/assets/solution/solutionList-en";
export default {
  name: "IristarSwzy",
  computed: {
    solutionDetial() {
      let list =
        this.$store.state.language === "zh" ? solutionList : solutionListEn;
      return list[7];
    },
    list() {
      return this.solutionDetial.infoData[this.indexVal].img.filter((item) => {
        return item.type !== "row";
      });
    },
  },
};
</script>

<style scoped>
</style>